import { Dispatch, SetStateAction } from 'react';
import { MainContainer } from '../../../layouts/MainContainer';
import { OnlyInMobile, OnlyInPc } from '../../../layouts/Responsive';
import { SubNaviForSp } from './ForSp';
import { SubNaviForPc } from './ForPc';

type Props = {
  isSubNaviOpen: boolean;
  setIsSubNaviOpen: Dispatch<SetStateAction<boolean>>;
};
export const SubNavi: React.FC<Props> = ({ isSubNaviOpen, setIsSubNaviOpen }) => {
  return (
    <MainContainer>
      <OnlyInPc>
        <SubNaviForPc isSubNaviOpen={isSubNaviOpen} />
      </OnlyInPc>
      <OnlyInMobile>
        <SubNaviForSp isSubNaviOpen={isSubNaviOpen} setIsSubNaviOpen={setIsSubNaviOpen} />
      </OnlyInMobile>
    </MainContainer>
  );
};
